
/* injects from baggage-loader */

/*global NODE_ENV*/
'use strict';

/**
 * Provider for the application routes configuration.
 *
 * @export
 * @param {AngularModule} app
 */
export default function (app) {
	app.provider('routerHelper', routerHelperProvider);

	/**
	 * Function used for the register all application routes in the $stateProvider.
	 *
	 * @param {any} $locationProvider
	 * @param {any} $stateProvider
	 * @param {any} $urlRouterProvider
	 */
	function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
		'ngInject';

		this.$get = RouterHelper;

		/**
		 * for the environment different to development take away the '#!' to the URL.
		 */
		if (NODE_ENV !== 'development') {
			$locationProvider.html5Mode(true);
		}

		/**
		 * Helper for the register the application routes.
		 *
		 * @param {any} $state
		 * @returns
		 */
		function RouterHelper($state) {
			'ngInject';

			let hasOtherwise = false;

			let service = {
				configureStates: configureStates,
				getStates: getStates
			};

			return service;

			/**
			 * Function used for register the states(Routes UI-ROUTE).
			 *
			 * @param {any} states
			 * @param {any} otherwisePath
			 */
			function configureStates(states, otherwisePath) {

				states.forEach(function (state) {
					$stateProvider.state(state.state, state.config);
				});

				/**
				 * registers a default route if it has not yet been defined.
				 */
				if (otherwisePath && !hasOtherwise) {
					hasOtherwise = true;
					$urlRouterProvider.otherwise(otherwisePath);
				}
			}

			/**
			 * Function that return the routes configured in the application.
			 *
			 * @returns
			 */
			function getStates() { return $state.get(); }
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/routerHelper.provider.js